module.exports = __webpack_public_path__ + "img/m-banner-vbrohihj-pl-PL.fe811c73.jpg";